import { getRoles } from 'api/roles.api';
import { COUNTRY_OPTIONS, STATE_OPTIONS } from 'components/global/_helpers/global.consts';
import { handleRefreshDbUser } from 'components/global/_helpers/global.helpers';
import { $form, $user, $view } from 'signals/global.signals';
import displayError from 'utils/displayError';

export const fetchAndSetCompanySettingsData = async () => {
  $form.reset({});
  $view.update({
    isLoading: true,
    error: null,
  });

  try {
    await handleRefreshDbUser({ isSoft: true });
    const { data: roles } = await getRoles({ userType: $user.value.userType });

    const address = $user.value.organization?.addresses?.[0];

    $view.update({
      roleOptions: roles.map((role) => ({
        label: role.name,
        value: role.id,
      })),
      name: $user.value.organization?.name || '',
      logo: $user.value.organization?.logoImage || '',
      logoColors: $user.value.organization?.logoColors || [],
    });

    // Find matching option objects for select fields
    const countryOption = COUNTRY_OPTIONS.find(option => option.value === address?.countryCode);
    const provinceOption = STATE_OPTIONS.find(option => option.value === address?.provinceCode);

    $form.update({
      name: $user.value.organization?.name || '',
      email: $user.value.organization?.email || '',
      phone: $user.value.organization?.phone || '',
      website: $user.value.organization?.website || '',
      countryCode: countryOption || null,
      provinceCode: provinceOption || null,
      street: address?.street || '',
      city: address?.city || '',
      zip: address?.postalCode || '',
      logoImage: $user.value.organization?.logoImage || '',
      logoColors: $user.value.organization?.logoColors || [],
    });
  } catch (error) {
    displayError({
      message: 'Failed to load company settings. Please refresh the page.',
      title: 'Loading Error',
    });
  } finally {
    $view.update({ isLoading: false });
  }
};
